import React from 'react';
import { ImageContainer, Image, Link } from './StyledMapStatic';
import PropTypes from 'prop-types';

const MapStatic = (props) => {
  const { latitude, longitude, googleListing } = props?.fields;
  const lat = latitude?.value ? latitude?.value : null;
  const lng = longitude?.value ? longitude?.value : null;
  const apikey = props?.apiKey?.value ? props?.apiKey?.value : null;
  const googleListingUrl = googleListing?.value?.href ? googleListing?.value.href : null;
  const editMode = props.editMode;

  let staticMapUrl = '';

  if ((!lat || !lng || !apikey) && !editMode) {
    return null;
  }

  if (lat && lng && apikey) {
    staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat}%2c%20${lng}&zoom=15&scale=2&size=286x123&markers=color:red%7Csize:mid%7C${lat}%2c%20${lng}&key=${apikey}`;
  }
  return (
    <>
      {staticMapUrl ? (
        <ImageContainer>
          {googleListingUrl ? (
            <Link href={googleListingUrl} target="_blank" rel="noopener noreferrer">
              <Image src={staticMapUrl} alt="Open listing on Google Maps" />
            </Link>
          ) : (
            <Image src={staticMapUrl} alt="" />
          )}
        </ImageContainer>
      ) : (
        ''
      )}
    </>
  );
};

MapStatic.propTypes = {
  fields: PropTypes.shape({
    latitude: PropTypes.shape({
      value: PropTypes.string
    }),
    longitude: PropTypes.shape({
      value: PropTypes.string
    }),
    googleListing: PropTypes.shape({
      value: PropTypes.shape({
        href: PropTypes.string
      })
    })
  }),
  apiKey: PropTypes.shape({
    value: PropTypes.string
  }),
  editMode: PropTypes.bool
};

export default MapStatic;
